import { Metrics } from '../../../utils/metrics';
import { trackCommunicationMethodsInteraction } from '../tracking/trackingEventUtils';
export class Chat {
  static getSettings() {
    if (!window.hsConversationsSettings) {
      window.hsConversationsSettings = {
        loadImmediately: false
      };
    }
    return window.hsConversationsSettings;
  }
  static getWidget() {
    var _HubSpotConversations;
    return (_HubSpotConversations = window.HubSpotConversations) === null || _HubSpotConversations === void 0 ? void 0 : _HubSpotConversations.widget;
  }
  static getApi() {
    return window.HubSpotConversations;
  }
  static onReady(callback) {
    const api = Chat.getApi();
    if (api) {
      callback();
    } else {
      const existing = window.hsConversationsOnReady || [];
      window.hsConversationsOnReady = [...existing, callback];
    }
    return Chat;
  }
  static getStatus() {
    var _Chat$getWidget;
    const status = (_Chat$getWidget = Chat.getWidget()) === null || _Chat$getWidget === void 0 ? void 0 : _Chat$getWidget.status();
    return {
      loaded: !!(status !== null && status !== void 0 && status.loaded),
      pending: !!(status !== null && status !== void 0 && status.pending)
    };
  }
  static updateSettings(settings) {
    Object.assign(Chat.getSettings(), settings);
    return Chat;
  }
  static setInlineEmbed(selector) {
    Chat.getSettings().inlineEmbedSelector = selector;
    return Chat;
  }
  static removeInlineEmbed() {
    delete Chat.getSettings().inlineEmbedSelector;
    return Chat;
  }
  static load() {
    return Chat.onReady(() => {
      Chat.getWidget().load();
    });
  }
  static refresh() {
    return Chat.onReady(() => {
      Chat.getWidget().refresh();
    });
  }
  static remove() {
    return Chat.onReady(() => {
      Chat.getWidget().remove();
    });
  }

  /**
   * @param event - {@link https://github.com/HubSpotEngineering/conversations-visitor/blob/master/conversations-embed/static/js/event-emitter/constants/eventTypeConstants.ts}
   * @param callback - Callback function that will be called when the event is emitted.
   * @returns Chat
   */
  static on(event, callback) {
    return Chat.onReady(() => {
      var _Chat$getApi;
      (_Chat$getApi = Chat.getApi()) === null || _Chat$getApi === void 0 || _Chat$getApi.on(event, callback);
    });
  }
  static off(event, callback) {
    var _Chat$getApi2;
    (_Chat$getApi2 = Chat.getApi()) === null || _Chat$getApi2 === void 0 || _Chat$getApi2.off(event, callback);
    return Chat;
  }
  static setupTracking(trackingSource) {
    return Chat.onReady(() => {
      if (Chat.hasSetupTracking) {
        return;
      }
      Chat.hasSetupTracking = true;
      trackCommunicationMethodsInteraction({
        action: 'chat-conversation-loaded',
        trackingSource
      });
      Metrics.counter('live-chat-loaded', {
        location: trackingSource
      }).increment();
      const api = Chat.getApi();
      if (api) {
        api.on('conversationStarted', payload => {
          trackCommunicationMethodsInteraction({
            action: 'chat-conversation-started',
            trackingSource,
            conversationId: payload.conversation.conversationId
          });
          Metrics.counter('live-chat-interaction', {
            location: trackingSource
          }).increment();
        });
      }
    });
  }
}
Chat.hasSetupTracking = false;